var map = {
	"./Home": [
		2829,
		829
	],
	"./Home/": [
		2829,
		829
	],
	"./Home/index": [
		2829,
		829
	],
	"./Home/index.tsx": [
		2829,
		829
	],
	"./Impressum": [
		2306,
		306
	],
	"./Impressum/": [
		2306,
		306
	],
	"./Impressum/index": [
		2306,
		306
	],
	"./Impressum/index.tsx": [
		2306,
		306
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 717;
module.exports = webpackAsyncContext;